import "./WaterPressureProblems.module.css";
import Header from "@/reusable_sections/Header";
import PressureOverview from "./sections/PressureOverview";
import PressureSymptoms from "./sections/PressureSymptoms";
import ServiceArea from "./sections/ServiceArea";
import Footer from "@/reusable_sections/Footer";
export default function WaterPressureProblemsPage() {
  return <div>
      <Header />
      <PressureOverview />
      <PressureSymptoms />
      <ServiceArea />
      <Footer />
    </div>;
}